import { useCallback, useMemo } from "react";
import SubscriptionDetails from "../../Subscription/SubscriptionDetails";
import { Colors } from "../../../utils/colors";
import StandardBorderedContainer from "../../Containers/StandardBorderedContainer";
import {
  MARKITAI,
  MARKIT_HOTLINE_NUMBER,
  mostRecentSubscriptionPlan,
} from "@markit/common.utils";
import { useSelector } from "react-redux";
import { getAccountState } from "../../../redux/slices/accountSlice";
import { RWebShare } from "react-web-share";
import { onShareLink } from "../../../utils/shareLink";
import { Icon } from "@iconify/react";
import SubscriptionPlanCard from "../../Subscription/SubscriptionPlanCard";
import RectangleButton from "../../Buttons/RectangleButton";
import { formatPhoneNumber } from "../../../utils/FormatPhoneNumber";
import TextingPanelUsage from "../TextingPanelUsage";
import { testStripe } from "../../../utils/stripeAccountUtils";

const BillingPanel = () => {
  const { accountData } = useSelector(getAccountState).account;

  const styles = {
    bodyMedium: {
      fontSize: 14,
      color: Colors.GRAY1,
    },
    bodyMediumBold: {
      fontSize: 14,
      fontWeight: 500,
      color: Colors.BLACK,
    },

    headerText: {
      fontSize: 32,
    },
  };

  const subscriptionPlan = useMemo(
    () => mostRecentSubscriptionPlan(accountData, testStripe(accountData.uid)),
    [accountData]
  );

  const shareMarkit = useCallback(async () => {
    await onShareLink("Share Markit with your friends!", MARKITAI);
  }, []);

  return (
    <div className="RowNormal" style={{ gap: 24 }}>
      <div className="ColumnNormal" style={{ gap: 24, flex: 1 }}>
        <SubscriptionDetails />
        <StandardBorderedContainer
          containerStyles={{
            backgroundColor: Colors.WHITE,
            borderRadius: 20,
            padding: 14,
          }}
        >
          <RWebShare data={{ url: MARKITAI }}>
            <div className="AlignedRowSpacedSelect" onClick={shareMarkit}>
              <span style={styles.bodyMediumBold}>Share Markit</span>
              <Icon
                icon="mdi:chevron-right"
                height={24}
                style={{ color: Colors.GRAY1 }}
              />
            </div>
          </RWebShare>
        </StandardBorderedContainer>
      </div>
      <div className="ColumnNormal" style={{ flex: 1, gap: 24 }}>
        <TextingPanelUsage onBilling />
        <SubscriptionPlanCard
          fullWidth
          cardButton={
            <RectangleButton
              buttonLabel="Current Plan"
              onPress={() => {}}
              altColor={Colors.GRAY6}
              disabled
              altPaddingHorz={14}
              altPaddingVert={14}
              containerStyles={{ marginTop: 10 }}
            />
          }
          isSelected={false}
          subscriptionPlan={subscriptionPlan}
        />
        <span style={{ ...styles.bodyMedium, textAlign: "center" }}>
          For enterprise or other questions contact sales at{" "}
          <span style={{ color: Colors.BLACK }}>
            {formatPhoneNumber(MARKIT_HOTLINE_NUMBER)}
          </span>
        </span>
      </div>
    </div>
  );
};

export default BillingPanel;
